import React from "react";
import { ComposableMap, Geographies, Geography, Marker, Line } from "react-simple-maps";
import { mapNodes, mapLinks } from "@/data/mockData";

const GEO_URL = "https://cdn.jsdelivr.net/npm/world-atlas@2/countries-110m.json";

const nodeByName = Object.fromEntries(mapNodes.map((n) => [n.name, n.coordinates]));

export default function WorldMapBackground({ fixed = true }) {
  return (
    <div
      aria-hidden
      className={`${fixed ? "fixed" : "absolute"} inset-0 -z-10 overflow-hidden pointer-events-none`}
      style={{ opacity: "var(--map-opacity)" }}
    >
      {/* soft radial vignettes for energy */}
      <div className="absolute -top-40 -left-40 h-[520px] w-[520px] rounded-full bg-electric/10 blur-3xl" />
      <div className="absolute top-1/3 -right-40 h-[520px] w-[520px] rounded-full bg-violet/10 blur-3xl" />
      <div className="absolute bottom-0 left-1/4 h-[420px] w-[420px] rounded-full bg-aqua/10 blur-3xl" />

      <ComposableMap
        projectionConfig={{ scale: 205, center: [12, 18] }}
        width={1600}
        height={820}
        className="h-full w-full"
        style={{ width: "100%", height: "100%" }}
      >
        <Geographies geography={GEO_URL}>
          {({ geographies }) =>
            geographies.map((geo) => (
              <Geography
                key={geo.rsmKey}
                geography={geo}
                fill="hsl(var(--map-fill))"
                stroke="hsl(var(--map-fill))"
                strokeWidth={0.3}
                style={{ default: { outline: "none" }, hover: { outline: "none" }, pressed: { outline: "none" } }}
              />
            ))
          }
        </Geographies>

        {mapLinks.map(([a, b], i) => (
          <Line
            key={`link-${i}`}
            from={nodeByName[a]}
            to={nodeByName[b]}
            stroke="hsl(var(--chart-2))"
            strokeWidth={1.1}
            strokeLinecap="round"
            strokeDasharray="4 8"
            style={{ animation: `cv-dash ${14 + i}s linear infinite`, opacity: 0.55 }}
          />
        ))}

        {mapNodes.map((n) => (
          <Marker key={n.name} coordinates={n.coordinates}>
            <circle r={5} fill="hsl(var(--chart-2))" opacity={0.9} />
            <circle
              r={5}
              fill="none"
              stroke="hsl(var(--chart-2))"
              strokeWidth={1.5}
              style={{ animation: "cv-pulse-node 3.4s ease-out infinite", transformOrigin: "center" }}
            />
          </Marker>
        ))}
      </ComposableMap>
    </div>
  );
}
